import { createRouter, createWebHashHistory } from "vue-router";
import { hasMenuAccess, firstAccessiblePath } from "@/components/Menu.js";
import { api } from "@/helpers/api";

const routes = [
  {
    path: "/",
    alias: "/painel-controle",
    name: "painel-controle",
    component: () => import("../views/dashboards/PainelControle.vue"),
  },
  {
    path: "/app/estatisticas/geral",
    name: "estatisticas-geral",
    component: () => import("../views/estatisticas/Geral.vue"),
  },
  {
    path: "/app/estatisticas/produtos",
    name: "estatisticas-produtos",
    component: () => import("../views/estatisticas/Produtos.vue"),
  },
  {
    path: "/app/estatisticas/clientes",
    name: "estatisticas-clientes",
    component: () => import("../views/estatisticas/Clientes.vue"),
  },
  {
    path: "/app/estatisticas/documentos",
    name: "estatisticas-documentos",
    component: () => import("../views/estatisticas/Documentos.vue"),
  },
  {
    path: "/app/estatisticas/dashboard-fe",
    name: "estatisticas-fe",
    component: () => import("../views/estatisticas/DashboardFe.vue"),
  },
  {
    path: "/app/estatisticas/financeiro",
    name: "estatisticas-financeiro",
    component: () => import("../views/estatisticas/Financeiro.vue"),
  },
  {
    path: "/app/facturacao/clientes",
    name: "app-clientes",
    component: () => import("../views/app/operations/Cliente.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/facturacao/documento",
    name: "app-documentos",
    component: () => import("../views/app/Documentos.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/facturacao/pos",
    name: "app-pos",
    component: () => import("../views/app/Pos.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/facturacao/seguradoras",
    name: "app-seguradoras",
    component: () => import("../views/app/operations/Seguradoras.vue"),
    meta: { dashboard: "geral", insuranceSection: "seguradoras" },
  },
  {
    path: "/app/facturacao/pessoas-cobertas",
    name: "app-pessoas-cobertas",
    component: () => import("../views/app/operations/Seguradoras.vue"),
    meta: { dashboard: "geral", insuranceSection: "pessoas" },
  },
  {
    path: "/app/facturacao/catalogo-atos",
    name: "app-catalogo-atos",
    component: () => import("../views/app/operations/Seguradoras.vue"),
    meta: { dashboard: "geral", insuranceSection: "atos" },
  },
  {
    path: "/app/facturacao/atos",
    name: "app-facturar-atos",
    component: () => import("../views/app/operations/FacturarActos.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/facturacao/relatorio-seguradoras",
    name: "app-relatorio-seguradoras",
    component: () =>
      import("../views/app/operations/RelatorioFacturasSeguradoras.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/website/noticias",
    name: "website-noticias",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "noticias" },
  },
  {
    path: "/app/website/eventos",
    name: "website-eventos",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "eventos" },
  },
  {
    path: "/app/website/slideshow",
    name: "website-slideshow",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "slideshow" },
  },
  {
    path: "/app/website/equipe",
    name: "website-equipe",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "equipe" },
  },
  {
    path: "/app/website/galeria",
    name: "website-galeria",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "galeria" },
  },
  {
    path: "/app/website/parceiros",
    name: "website-parceiros",
    component: () => import("../views/app/operations/WebsiteConteudos.vue"),
    meta: { dashboard: "geral", websiteSection: "parceiros" },
  },
  {
    path: "/app/website/agendamentos",
    name: "website-agendamentos",
    component: () => import("../views/app/operations/AgendamentosWebsite.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/estoque/especialidades",
    name: "estoque-especialidades",
    component: () => import("../views/estoque/Especialidades.vue"),
  },
  {
    path: "/app/tesouraria/secretaria/pagamentos",
    alias: ["/app/documentos", "/app/facturacao/anular-documento"],
    name: "documentos",
    component: () => import("../views/app/Documentos.vue"),
    meta: { dashboard: "geral" },
  },
  {
    path: "/app/facturacao/documentos-emitidos",
    name: "documentos-emitidos",
    component: () => import("../views/app/DocumentosEmitidos.vue"),
  },
  {
    path: "/app/facturacao/anular-factura",
    name: "anular-factura",
    component: () => import("../views/app/AnularFactura.vue"),
  },
  {
    path: "/app/facturacao/listar-facturas",
    name: "listar-facturas-agt",
    component: () => import("../views/app/ListarFacturasAgt.vue"),
  },
  {
    path: "/app/facturacao/consultar-factura",
    name: "consultar-factura",
    component: () => import("../views/app/ConsultarFactura.vue"),
  },
  {
    path: "/app/ferramentas/velocidade",
    name: "teste-velocidade",
    component: () => import("../views/app/TesteVelocidade.vue"),
  },
  {
    path: "/auth/login",
    name: "login",
    component: () => import("../views/auth/Login.vue"),
  },
  {
    path: "/auth/redefinir-senha",
    name: "redefinir-senha",
    component: () => import("../views/auth/RedefinirSenha.vue"),
  },
  {
    path: "/perfil",
    name: "perfil",
    component: () => import("../views/auth/Perfil.vue"),
  },
  {
    path: "/empresa/licenciamento",
    name: "licenciamento",
    component: () => import("../views/auth/Licenciamento.vue"),
  },
  {
    path: "/empresa/perfil",
    name: "empresa-perfil",
    component: () => import("../views/auth/PerfilEmpresa.vue"),
  },
  {
    path: "/empresa/estabelecimentos",
    name: "estabelecimentos",
    component: () => import("../views/auth/Estabelecimentos.vue"),
  },
  {
    path: "/auth/empresas",
    name: "empresas",
    component: () => import("../views/auth/Empresa.vue"),
  },
  {
    path: "/auth/users",
    alias: "/utilizadores",
    name: "users",
    component: () => import("../views/auth/Users.vue"),
  },
  {
    path: "/config/bancos",
    name: "bancos",
    component: () => import("../views/config/Banco.vue"),
  },
  {
    path: "/app/estoque/produtos",
    name: "estoque-produtos",
    component: () => import("../views/estoque/Produtos.vue"),
  },
  {
    path: "/app/estoque/servicos",
    name: "estoque-servicos",
    component: () => import("../views/estoque/Servicos.vue"),
  },
  {
    path: "/app/estoque/ajuste",
    name: "estoque-ajuste",
    component: () => import("../views/estoque/AjusteEstoque.vue"),
  },
  {
    path: "/app/estoque/inventario",
    name: "estoque-inventario",
    component: () => import("../views/estoque/Inventario.vue"),
  },
  {
    path: "/config/categorias",
    name: "categorias",
    component: () => import("../views/config/Categoria.vue"),
  },
  {
    path: "/config/armazens",
    name: "armazens",
    component: () => import("../views/config/Armazen.vue"),
  },
  {
    path: "/app/tesouraria/secretaria/despesas",
    name: "despesas",
    component: () => import("../views/app/Despesas.vue"),
  },
  {
    path: "/app/relatorios/fluxo-caixa",
    alias: "/app/relatorios",
    name: "relatorio-fluxo-caixa",
    component: () => import("../views/app/reports/FluxoCaixa.vue"),
    meta: { reportTab: "fluxo" },
  },
  {
    path: "/app/relatorios/devedores",
    name: "relatorio-devedores",
    component: () => import("../views/app/reports/ListaDevedores.vue"),
    meta: { reportTab: "conta" },
  },
  {
    path: "/app/relatorios/conta-corrente",
    name: "relatorio-conta-corrente",
    component: () => import("../views/app/reports/ListaDevedores.vue"),
    meta: { reportTab: "conta" },
  },
  {
    path: "/app/relatorios/fecho-diario",
    name: "relatorio-fecho-diario",
    component: () => import("../views/app/reports/FluxoCaixa.vue"),
    meta: { reportTab: "fecho" },
  },
  {
    path: "/app/relatorios/saft",
    name: "relatorio-saft",
    redirect: "/app/relatorios/fluxo-caixa",
  },
  {
    path: "/config/series",
    name: "series",
    component: () => import("../views/config/Serie.vue"),
  },
  {
    path: "/config/importar-dados",
    name: "importar-dados",
    component: () => import("../views/config/ImportarDados.vue"),
  },
  {
    path: "/auth/notificacoes",
    name: "notificacoes",
    component: () => import("../views/app/Notificacoes.vue"),
  },
  {
    path: "/auth/actividades",
    name: "auth-actividades",
    component: () => import("../views/auth/Actividades.vue"),
  },
  {
    path: "/actividades",
    name: "actividades",
    component: () => import("../views/auth/Actividades.vue"),
  },
  {
    path: "/erro/403",
    name: "forbidden",
    component: () => import("../views/errors/error403.vue"),
  },
  {
    path: "/erro/500",
    name: "server-error",
    component: () => import("../views/errors/error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../views/errors/error404.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});

const LICENSE_CHECKED_AT_KEY = "facturize_license_checked_at";
const LICENSE_CHECK_INTERVAL_MS = 60 * 1000;
let licenseCheckInFlight = null;

function licenseCheckIsDue() {
  const checkedAt = Number(sessionStorage.getItem(LICENSE_CHECKED_AT_KEY) || 0);
  return !checkedAt || Date.now() - checkedAt >= LICENSE_CHECK_INTERVAL_MS;
}

async function checkLicenseStatus() {
  if (licenseCheckInFlight) return licenseCheckInFlight;

  const pending = (async () => {
    try {
      const { data } = await api.get("/licensas/status", { timeout: 15000 });
      if (data?.valid === false) {
        sessionStorage.removeItem(LICENSE_CHECKED_AT_KEY);
        return true;
      }
      sessionStorage.setItem(LICENSE_CHECKED_AT_KEY, String(Date.now()));
      return false;
    } catch (error) {
      const response = error.response;
      if (response?.status === 423 || response?.status === 503 || !response) {
        sessionStorage.removeItem(LICENSE_CHECKED_AT_KEY);
        return true;
      }
      // Do not cache a failed/unavailable check; the next navigation or timer
      // retries it without blocking the UI on a transient network issue.
      return false;
    }
  })();

  licenseCheckInFlight = pending;
  try {
    return await pending;
  } finally {
    if (licenseCheckInFlight === pending) licenseCheckInFlight = null;
  }
}

router.onError((error) => {
  console.error("Erro ao carregar a interface Facturize:", error);
});

router.beforeEach(async (to) => {
  const logged = Boolean(localStorage.getItem("facturize_token"));

  if (!["login", "empresas", "redefinir-senha"].includes(to.name) && !logged)
    return { name: "login", query: { redirect: to.fullPath } };

  if (["login", "empresas"].includes(to.name) && logged)
    return { name: "painel-controle" };

  if (
    logged &&
    ![
      "login",
      "empresas",
      "licenciamento",
      "perfil",
      "forbidden",
      "server-error",
      "not-found",
    ].includes(to.name)
  ) {
    if (licenseCheckIsDue()) {
      const blocked = await checkLicenseStatus();
      if (blocked && to.name !== "licenciamento")
        return { name: "licenciamento" };
    }
    const role = JSON.parse(
      localStorage.getItem("facturize_user") || "null",
    )?.nivel;
    if (role && !hasMenuAccess(to.path, role)) return firstAccessiblePath(role);
  }
});

// Keep an already-open POS session in sync when the license is blocked from the
// central admin, even if the user does not navigate between pages.
window.setInterval(async () => {
  if (!localStorage.getItem("facturize_token")) {
    sessionStorage.removeItem(LICENSE_CHECKED_AT_KEY);
    return;
  }
  if (!licenseCheckIsDue()) return;
  const blocked = await checkLicenseStatus();
  if (blocked && router.currentRoute.value.name !== "licenciamento") {
    router.replace({ name: "licenciamento" });
  }
}, LICENSE_CHECK_INTERVAL_MS);

export default router;
